<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Search-Policy",
  path: "policy",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
